import React from "react";
import TimerCountDown from "../../../ui/clock/count-down-timer/count-down-timer";
import {getTimerCounterDataFromHtml} from "../../../ui/clock/clock-provider";
const TIMER_ID = "subscription-timer-1";
export const MainBannerPriceDifferent = () => {


    const timerFromHtml = getTimerCounterDataFromHtml(TIMER_ID);
    const imgTop = timerFromHtml ? "top-sbs-3rows" : "top-sbs-2rows";
    /*const scrollToPlans = () => {
        const $el = document.getElementById('plans-container');
        if(!$el) return;

        window.scrollTo({
            top: $el.offsetTop,
            left: 0,
            behavior: "smooth",
        });
    }*/
    return (
        <>
            {/*Default title*/}
            <div className="main-bnr pb-2 md:pb-2">
                <section className="main-bnr w-full">

                    <div className="relative flex flex-col lg:flex-row">
                        <div className="dv-image md:order-2">
                            <picture className="w-full">
                                <source
                                    srcSet={`https://media.wavescdn.com/images/homepage/2025/july/sbs-new-users/top-sbs-2rows-d.png`}
                                    media="(min-width: 1800px)"/>
                                <source
                                    srcSet={`https://media.wavescdn.com/images/homepage/2025/july/sbs-new-users/${imgTop}-d.png`}
                                    media="(min-width: 1280px)"/>
                                <source
                                    srcSet={`https://media.wavescdn.com/images/homepage/2025/july/sbs-new-users/${imgTop}-d.png`}
                                    media="(min-width: 1024px)"/>
                                <source
                                    srcSet={`https://media.wavescdn.com/images/homepage/2025/july/sbs-new-users/top-sbs-3rows-d.png`}
                                    media="(min-width: 768px)"/>
                                <source
                                    srcSet={`https://media.wavescdn.com/images/homepage/2025/july/sbs-new-users/${imgTop}-m.png?fit=max`}
                                    media="(min-width: 0px)"/>
                                <img
                                    src={`https://media.wavescdn.com/images/homepage/2025/july/sbs-new-users/${imgTop}-d.png`}
                                    className="w-full" alt="Subscription"/>
                            </picture>
                        </div>
                        <div className="w-full top-absolute new-user-2025 md:order-1">
                            <div className="w-full w-absolute flex flex-col pt-4 md:pt-0">
                                <div className="w-full text-center md:text-center">
                                    {timerFromHtml && <div className="w-full timer-container pb-4">
                                        <div className="w-full flex justify-center">
                                            <TimerCountDown
                                                expiredWhenNumber={0}
                                                timerType=""
                                                loadDataFromHtml={TIMER_ID}
                                            />
                                        </div>
                                    </div>}

                                    <div className="text-base md:text-xl xl:text-2xl line-height-normal font-montserrat bg-yellow-400 w-fit mx-auto font-bold px-4 py-1 md:py-2 rounded">
                                        Black Friday Sale!
                                    </div>
                                    <div
                                        className="top-title w-full text-xl md:text-4xl xl:text-6xl line-height-normal font-bold font-montserrat lg:py-2">
                                        <h1 className="w-full my-4">
                                            <span className="text-white">Waves Creative Access</span><br/>
                                            <span className="text-yellow-400">20% Off Annual Subscriptions</span>
                                        </h1>
                                    </div>
                                    <div className="text-base md:text-xl xl:text-2xl line-height-normal pt-1 md:pt-2 font-montserrat text-white">
                                        240+ Waves Plugins. One Subscription.
                                    </div>

                                    <div className="mt-4 xl:mt-6 text-center text-xs">
                                        <a href="/legal/annual-subscriptions-promotion-november-2026-terms-and-conditions"
                                           className="no-underline hover:underline text-white" data-gaevent="Click"
                                           data-gavalue="SBS page: Price different Terms">
                                            Terms & conditions apply</a>.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
};